<template>
  <div>
      <div class="money-pannel">
            <div class="money">
                <div class="nums">{{ info.total_settlement_amount || 0.0 }}</div>
                <div class="title">
                    <!-- 累计赚得 -->
                    {{$t('accumulated')}}
                </div>
            </div>
            <div class="money">
                <div  class="nums">{{ info.settlement_amount || 0.0 }}</div>
                <div class="title">
                    <!-- 已结算 -->
                   Withdrawable Amount
                </div>
            </div>
            <div class="money">
                <div  class="nums">{{ userInfo.balance || 0.0 }}</div>
                <div class="title">
                    <!-- 可提现金额 -->
                    Available Balance
                </div>
            </div>
            <div class="money">
                <div class="btn"  @click="apply">
                    <!-- 申请提现 -->
                    Withdrawal
                </div>
            </div>
      </div>
    <!-- 推广的订单 -->
      <div class="table">
        <el-table
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
        <el-table-column
            width="180"
            prop="order_id"
            label="Order Number">
        </el-table-column>
        <el-table-column
            prop="user"
            label="Name"
           >
        </el-table-column>

        <el-table-column
            prop="is_settlement"
            label="Status"
            >
        </el-table-column>
        
         <el-table-column
            prop="payed"
            label="Paid Amount"
            >
        </el-table-column>
         <el-table-column
            prop="order_amount"
            :label="$t('grandtotal')"
            >
        </el-table-column>

         <el-table-column
            prop="amount"
            :label="$t('commission')"
            >
        </el-table-column>

        
        <el-table-column
            prop="buy_user"
            label="Date"
            >
        </el-table-column>

        
       
        </el-table>
      </div>

      <Pagination
        v-if="tableData.length>0"
        :totalPage="totalPage"
        :limit="10"
        @changePage="handleCurrentChange"
      ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            info: {},
            userInfo: {},
            tableData: [],
            limit: 10,
            page: 1,
            totalPage: 0
        }
    },
    created() {
        this.init()
        this.tableList()
        this.$api.userInfo().then(res => {
            if(res.status) {
                this.userInfo = res.data
            }
        })
    },
    methods: {
         // 申请提现跳转
        apply() {
            this.$router.push({
                path: '/center/withdrawCash'
            })
        },
        handleCurrentChange() {
            this.page += 1
            this.tableList()
        },
        // 推荐订单
        tableList() {
            let data = {
                page: this.page,
                limit: this.limit
            }
            this.$api.channelbusinessGetorder(data).then(res =>{
                if(res.status) {
                    this.tableData = res.data.list
                    this.totalPage = Math.ceil(res.data.count / this.limit) 
                }
            })
        },
        init() {
            // 渠道商信息
            this.$api.channelbusinessGetInfo().then(res => {
                if(res.status) {
                    this.info = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.money-pannel {
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #ffccbc;
    border-top: 5px solid #ffccbc;
    padding: 20px 0;
    .money {
        float: left;
        width: 25%;
        border-right: 1px solid #fbe9e7;
        text-align: center;
        margin: -1px;
        font-size: 32px;
        color: #ff5722;
        cursor: pointer;
        .nums {
            font-weight: bold;
            float: none;
            margin-left: 0px;
            color: #ff5722;
            font-size: 32px;
            border: 0;
        }
        .title {
            font-weight: normal;
            font-size: 14px;
            color: #666;
            width: 100%;
            display: inline-block;
        }
        .btn {
            width: 170px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background: #ff5722;
            color: #fff;
            display: inline-block;
            font-size: 16px;
            border-radius: 4px;
        }
    }
}
</style>